'use strict';

import { _form } from './_form';
import { stateCity } from '../../modules/select';

const edit = {
  init() {
    _form();
    stateCity();
  },
};

const _this = edit;

export default _this;
